import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import { AnalyticsEvent } from 'utils/analytics'
import { CopyGalleryLink } from 'components/pages/Gallery/common/CopyGalleryLink/CopyGalleryLink.module'
import { MUIButton } from 'components/common/MUIButton'
import { PageActions } from 'components/common/Page/PageActions'
import { Path } from 'constants/router'
import React from 'react'
import { useClientProperty } from '../../ClientProperty/_main/contexts'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface Props {
  /** Property ID */
  propertyId?: string
}

export const PropertyPageActions: React.FC<Props> = ({ propertyId }) => {
  const { t } = useTranslation(['property'])
  const navigate = useNavigate()

  const { handleClickOnEmptyAction } = useClientProperty()

  return (
    <PageActions key={`property-page-actions-${propertyId}`}>
      <CopyGalleryLink propertyId={propertyId} />

      <MUIButton
        onClick={() => {
          handleClickOnEmptyAction(AnalyticsEvent.PROPERTY_ORDER_VISUALS_OVERVIEW_HEADER_CLICKED)
          navigate({ pathname: Path.PURCHASE_FLOW, search: `?realtyId=${propertyId}` })
        }}
        startIcon={<AddCircleOutlineOutlinedIcon fontSize="large" />}
      >{t('add_new_assignment')}
      </MUIButton>

    </PageActions>
  )
}
